import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
//react-icons
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
//css
import "./DevicePage.css";
//properties
import { properties } from "../../helpers/properties";
//loader
import AssignDevice from "./AssignDevice";
import ReleaseDevice from "./ReleaseDevice";

const DevicePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [assignedDevice, setAssignedDevice] = useState({});
    const [isUserAssigned, setIsUserAssigned] = useState(false);
    const [deviceList, setDeviceList] = useState([]);
    const [Error, setError] = useState(false);

    const { country, countryId, userSsoId, authToken } = location.state || [];

    useEffect(() => {
        fetchDevices();
    }, [authToken]);

    if (!countryId || countryId === null || !userSsoId || userSsoId === null) {
        navigate("/");
    }

    const changeLocation = () => {
        navigate("/");
    }

    const updateDeviceList = (devices) => {
        const updatedDeviceList = devices.map((device) => {
            if (device.assignedStatus === "ASSIGNED" && device.ssoId !== userSsoId) {
                return {
                    ...device,
                    isDisabled: true,
                    value: `${device.deviceName}-${device.serialNumber}-${device.ssoId}`,
                    label: `${device.deviceName}-${device.serialNumber}-${device.ssoId}`,
                };
            }
            else {
                return {
                    ...device,
                    value: `${device.deviceName}-${device.serialNumber}`,
                    label: `${device.deviceName}-${device.serialNumber}`,
                };
            }
        });
        setDeviceList(updatedDeviceList);
        checkDeviceAssigned(updatedDeviceList);
    }

    const checkDeviceAssigned = (devices) => {
        const assignedDevice = devices.find(device => (device.ssoId === userSsoId && device.assignedStatus === "ASSIGNED"));
        if (assignedDevice) {
            setIsUserAssigned(true);
            setAssignedDevice(assignedDevice);
        } else {
            setIsUserAssigned(false);
            setAssignedDevice({});
        }
    }

    const fetchDevices = () => {
        axios.get(process.env.REACT_APP_API_URL + `/v1/locations/${countryId}/devices`, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    updateDeviceList(response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching devices:", error);
                setError(true);
            })
    };

    return (
        <>
            <div className='device-page-container'>
                <div className="device-container">
                    {
                        deviceList.length === 0 ?
                            <>
                                <div className="skeleton-title skeleton-animation"></div>
                                <div className="skeleton-text-line skeleton-animation"></div>
                                <div className="skeleton-text-line skeleton-animation"></div>
                                <div className="skeleton-select skeleton-animation"></div>
                                <div className="skeleton-button skeleton-animation"></div>
                                <div className="skeleton-text-line skeleton-animation"></div>
                            </> :
                            <>
                                <h2 className="title">Device Management</h2>
                                <span className="country-info">
                                    <p>Device belongs to: <span className="device-country">{country}</span></p>
                                    <span className="location-search" onClick={changeLocation}>
                                        <MdOutlineKeyboardArrowLeft size="1.4em" />
                                        <span className="location-search-text">Back to location selection</span>
                                    </span>
                                </span>

                                {Error
                                    ?
                                    <div className="error-message">{properties.DEVICE_NOT_FOUND}</div>
                                    :
                                    (!isUserAssigned
                                        ?
                                        <AssignDevice deviceList={deviceList} fetchDevices={fetchDevices} countryId={countryId} userSsoId={userSsoId} authToken={authToken} />
                                        :
                                        <>
                                            <ReleaseDevice assignedDevice={assignedDevice} fetchDevices={fetchDevices} countryId={countryId} userSsoId={userSsoId} authToken={authToken} />
                                            <a href="https://www.wiley.com" target="_blank" rel="noreferrer" className="visit-trade-show">
                                                <span className="visit-trade-show-text">Visit Trade Show</span>
                                                <MdOutlineKeyboardArrowRight size="1.4em" className="visit-trade-show-icon" />
                                            </a>
                                        </>
                                    )
                                }

                            </>
                    }
                </div>
            </div>

        </>
    );
};
export default DevicePage;